/** "While you were away": built from the log in `welcome`, or the server's summary when the log is too short. */
import type { AwaySummary, LogEntry, WelcomeMsg } from '@bramvasterd/terrella-protocol';

export function summarizeAway(since: WelcomeMsg['since'], me: string): AwaySummary | null {
  if (!since) return null;
  const given = since as { log?: LogEntry[]; summary?: AwaySummary };
  const summary: AwaySummary = given.summary ?? fromLog(given.log ?? [], me);
  const { changes, grew, fell, sank, shattered, laid } = summary;
  if (Object.keys(changes).length === 0 && !grew && !fell && !sank && !shattered && !laid)
    return null;
  return summary;
}

/** What each other player did (placements, upgrades started, removals, gathering, loading), and what the planet, the charges and the infusers did. */
function fromLog(log: LogEntry[], me: string): AwaySummary {
  const summary: AwaySummary = {
    from: log[0]?.time ?? 0,
    changes: {},
    grew: 0,
    fell: 0,
    sank: 0,
    shattered: 0,
    laid: 0,
  };
  for (const entry of log) {
    for (const event of entry.events) {
      switch (event.kind) {
        case 'placed':
        case 'upgrading':
        case 'removed':
        case 'gathered':
        case 'loaded':
          if (event.player !== me)
            summary.changes[event.player] = (summary.changes[event.player] ?? 0) + 1;
          break;
        case 'grew':
          summary.grew++;
          break;
        case 'fell':
          summary.fell++;
          break;
        case 'sank':
          summary.sank++;
          break;
        case 'shattered':
          summary.shattered += event.tiles.length;
          break;
        case 'laid':
          summary.laid++;
          break;
        default:
          break;
      }
    }
  }
  return summary;
}
